var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { inject } from 'aurelia-dependency-injection';
import { customAttribute } from 'aurelia-templating';
import { DndService } from 'bcx-aurelia-dnd';
import { EventAggregator } from 'aurelia-event-aggregator';
import { ReorderableGroupMap } from './reorderable-group-map';
import repeaterDndType from './repeater-dnd-type';
const example = 'reorderable-group-for.bind="arrayModel"';
let ReorderableGroupFor = class ReorderableGroupFor {
    constructor(element, ea, dndService, groupMap) {
        this.intention = null;
        this.element = element;
        this.ea = ea;
        this.dndService = dndService;
        this.groupMap = groupMap;
        this.resetIntention = this.resetIntention.bind(this);
    }
    bind() {
        const { value } = this;
        if (!Array.isArray(value)) {
            throw new Error('reorderable-group-for needs items to be an array. e.g. ' + example);
        }
        this._subsribers = [
            this.ea.subscribe('dnd:willStart', () => {
                const repeaterInfo = this.groupMap.get(value);
                if (repeaterInfo) {
                    this.group = repeaterDndType(repeaterInfo.group());
                    this.repeaterId = repeaterDndType(repeaterInfo.repeaterId);
                }
                else {
                    this.group = null;
                    this.repeaterId = null;
                }
                this.resetIntention();
            }),
            this.ea.subscribe('dnd:didEnd', this.resetIntention),
            this.ea.subscribe('reorderable-group:intention-changed', intention => {
                if (intention.type !== this.group)
                    return;
                this.intention = intention;
            })
        ];
    }
    unbind() {
        this._subsribers.forEach(s => s.dispose());
        this._subsribers = [];
    }
    resetIntention() {
        this.intention = null;
    }
    attached() {
        this.dndService.addTarget(this, { element: this.element });
    }
    detached() {
        this.dndService.removeTarget(this);
    }
    dndCanDrop(model) {
        return model.type === this.group;
    }
    dndHover() {
        if (!this.repeaterId)
            return;
        const { isHoveringShallowly, model } = this.dnd;
        if (!isHoveringShallowly)
            return;
        const { type, index, item, repeaterId } = model;
        const length = this.value ? this.value.length : 0;
        const inSameGroup = model.repeaterId === this.repeaterId;
        const defaultTargetIndex = inSameGroup ? length - 1 : length;
        if (!this.intention || this.intention.toRepeaterId !== this.repeaterId) {
            this.ea.publish('reorderable-group:intention-changed', {
                type,
                item,
                fromIndex: index,
                fromRepeaterId: repeaterId,
                toIndex: defaultTargetIndex,
                toRepeaterId: this.repeaterId
            });
        }
    }
    dndDrop() {
    }
};
ReorderableGroupFor = __decorate([
    customAttribute('reorderable-group-for'),
    inject(Element, EventAggregator, DndService, ReorderableGroupMap),
    __metadata("design:paramtypes", [Object, Object, Object, Object])
], ReorderableGroupFor);
export { ReorderableGroupFor };

//# sourceMappingURL=reorderable-group-for.js.map
